// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_dropdown-footer_vm8qf_jxdvh_5:not(#\\9 ){overflow:hidden;flex-shrink:0}.awsui_dropdown-content_vm8qf_jxdvh_10:not(#\\9 ){display:contents}", ""]);
// Exports
module.exports = exports;
